function toDateKey(value) {
  if (!value) return "";
  const match = String(value).match(/^\d{4}-\d{2}-\d{2}/);
  return match ? match[0] : "";
}

export default {
  name: "RingPickupDateDialog",
  props: {
    visible: { type: Boolean, default: false },
    schedule: { type: Object, default: null },
    submitting: { type: Boolean, default: false },
  },
  data() {
    return { ringPickupExpectedDate: "" };
  },
  watch: {
    visible(isVisible) {
      if (!isVisible) return;
      this.ringPickupExpectedDate = toDateKey(
        this.schedule && this.schedule.ringPickupExpectedAt
      );
    },
  },
  methods: {
    submit() {
      if (!this.ringPickupExpectedDate) {
        this.$message.warning("반지 수령 예정일을 선택해 주세요.");
        return;
      }
      this.$emit("submit", this.ringPickupExpectedDate);
    },
  },
};
